import React from "react";
import { formatPrice } from "../../utils/formatPrice";
import "../../css/model.css";

const PriceBreakdownPanel = ({ priceBreakdownData }) => {
  if (!priceBreakdownData) return null;

  const { components, total } = priceBreakdownData;

  return (
    <div className="news_comments mt-4 price-breakdown">
      <div className="price-breakdown__header">
        <h2 className="price-breakdown__title">Price Breakdown</h2>
      </div>

      <div className="price-breakdown__list">
            <div className="price-breakdown__item header">
            <span className="price-breakdown__item-name">
              Name
            </span>
            <span className="price-breakdown__item-percentage">
              %
            </span>
            <span className="price-breakdown__item-price">
              Price
            </span>
          </div>
        {components.map((component) => (
          <div key={component.id} className="price-breakdown__item">
            <span className="price-breakdown__item-name">
              {component.name}
            </span>
            <span className="price-breakdown__item-percentage">
              {component.percentage}
            </span>
            <span className="price-breakdown__item-price">
              {formatPrice(component.price)} {component.currency}
            </span>
          </div>
        ))}
      </div>

      {total && (
        <div className="price-breakdown__item price-breakdown__total">
          <span className="price-breakdown__total-label">Total</span>
          <span className="price-breakdown__item-percentage"></span>
          <span className="price-breakdown__total-price">
            {formatPrice(total.price)} {total.currency}
          </span>
        </div>
      )}
    </div>
  );
};

export default PriceBreakdownPanel;
